import { GetterTree } from "vuex";
import { MessagesState, RootState } from "@/types/store/clientzone";

export const getters: GetterTree<MessagesState, RootState> = {
  GET_SELECTED_VENUE: (state) => state.selectedVenue,
  GET_MESSAGES: (state) => state.messages,
  GET_ERROR_MESSAGES: (state) => state.errorMessage,
}
